export const DndAppActionType = {
    USERPREFERENCE: 'USERPREFERENCE',
    OPEN_PAGE: 'OPEN_PAGE',
    OPEN_COMPLAINT_FORM: 'OPEN_COMPLAINT_FORM',
    CLOSE_COMPLAINT_FORM: 'CLOSE_COMPLAINT_FORM'
};